const chunk = (arr: any[], size: number) =>
  Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
    arr.slice(i * size, i * size + size)
  )
export const groupBy = (list: any[], keyGetter: any) => {
  const map = new Map()
  list.forEach((item) => {
    const key = keyGetter(item)
    const collection = map.get(key)
    if (!collection) {
      map.set(key, [item])
    } else {
      collection.push(item)
    }
  })
  return map
}

export const isEqual = (array1: any[], array2: any[]) => {
  return array1.sort().join('-') === array2.sort().join('-')
}

export default chunk

export const arrayUniqueByKey = (array: any[], key: string) => {
  return [...new Map(array.map((item) => [item[key], item])).values()]
}
